/* © CNES */
import { isDate } from 'moment';
import { Calendar } from 'primereact/calendar';
import './CustomCalendar.scss';

/**
 * Custom Calendar Props.
 */
export interface CustomCalendarProps {
  dateValue?: string | Date | null;
  onChange: (value: Date, key: string) => void;
  name: string;
}

/**
 * Custom Calendar.
 * @param dateValue string date displayed in calendar.
 * @param onChange Function handle date change.
 * @param name string id of calendar.
 * @returns Element.
 */
export const CustomCalendar = ({
  dateValue,
  onChange,
  name,
}: CustomCalendarProps) => {
  const handleChange = (
    value: string | Date | Date[] | undefined | null,
    key: string
  ) => {
    if (isDate(value)) {
      const newDate = new Date(value);
      onChange(newDate, key);
    }
  };

  return (
    <Calendar
      aria-label="calendar-input"
      id={name}
      value={dateValue}
      dateFormat="dd/mm/yy"
      onChange={(e) => handleChange(e.value, name)}
      showIcon
      showTime
      hideOnDateTimeSelect
    />
  );
};
